<section class="help-and-support" data-testid="help-and-support-section">
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="s">
    Help and support
  </goab-text>

  <goab-text tag="p" size="body-m" mt="none" mb="none">
    Find answers about capacity reporting, account changes, smoking policy, and
    how to contact support.
  </goab-text>

  <goab-divider mt="2xl" mb="2xl"></goab-divider>

  <goab-text tag="h2" size="heading-m" mt="none" mb="l">
    Get help with a request
  </goab-text>

  <goab-text tag="p" size="body-m" mt="none" mb="xs">
    To get help with capacity reporting, account changes, or facility details,
    <a
      class="help-and-support__request-link"
      [attr.href]="supportRequestHref"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="submit-support-request-link"
    >
      submit a support request
      <goab-icon type="open" size="small" [opacity]="1"></goab-icon>
    </a>
  </goab-text>

  <goab-spacer vSpacing="l"></goab-spacer>

  <goab-text tag="h4" size="heading-s" mt="none" mb="2xs">
    Timelines for responses
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="l">
    Email will be responded to within one to two business days. Account changes
    or requests require two business days to complete.
  </goab-text>

  <goab-text tag="h4" size="heading-s" mt="none" mb="2xs">
    About requests to change facility details
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="none">
    Changes to facility details (i.e., changes in the number of funded spaces,
    change to official site contact, facility name etc.) will be referred to
    Assisted Living and Social Services Continuing Care Licensing Office to
    approve any changes through standard processes.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="3xl">
    You may be asked to submit additional documentation to the Continuing Care
    Licensing Office depending on the nature of the inquiry. These may include
    an updated Notice to Director form or a Duty to Notify form. The Continuing
    Care Licensing Office will follow up on these inquiries through their usual
    processes.
  </goab-text>
</section>
